// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.get-involved {
  background: var(--white);
}

.ways-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
  margin-bottom: 64px;
}

.way-card {
  padding: 56px 40px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: var(--transition);
}

.way-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-xl);
}

.way-icon {
  width: 80px;
  height: 80px;
  border-radius: 20px;
  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--white);
  margin-bottom: 28px;
  transition: var(--transition);
}

.way-icon svg {
  width: 36px;
  height: 36px;
}

.way-card:hover .way-icon {
  transform: scale(1.1) rotate(-5deg);
}

.way-title {
  font-size: 26px;
  font-weight: 700;
  color: var(--dark-color);
  margin-bottom: 16px;
}

.way-description {
  font-size: 15px;
  line-height: 1.8;
  color: var(--text-light);
  margin-bottom: 28px;
  flex-grow: 1;
}

.way-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: var(--primary-color);
  transition: var(--transition);
}

.way-link:hover {
  gap: 12px;
  color: var(--secondary-color);
}

.way-link svg {
  flex-shrink: 0;
}

.newsletter-section {
  background: linear-gradient(135deg, var(--dark-color) 0%, #2D2D2D 100%);
  padding: 60px;
  border-radius: 20px;
  position: relative;
  overflow: hidden;
}

.newsletter-section::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -10%;
  width: 400px;
  height: 400px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(0, 163, 224, 0.15) 0%, transparent 70%);
}

.newsletter-content {
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 60px;
}

.newsletter-text {
  flex: 1 1;
  color: var(--white);
}

.newsletter-title {
  font-size: 32px;
  font-weight: 700;
  color: var(--white);
  margin-bottom: 12px;
}

.newsletter-description {
  font-size: 16px;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.8);
  max-width: 500px;
}

.newsletter-form {
  display: flex;
  gap: 12px;
  flex-shrink: 0;
  min-width: 400px;
}

.newsletter-input {
  flex: 1 1;
  padding: 16px 24px;
  border-radius: 8px;
  border: 2px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  color: var(--white);
  font-size: 15px;
  transition: var(--transition);
}

.newsletter-input::placeholder {
  color: rgba(255, 255, 255, 0.6);
}

.newsletter-input:focus {
  outline: none;
  border-color: var(--secondary-color);
  background: rgba(255, 255, 255, 0.15);
}

@media (max-width: 968px) {
  .ways-grid {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .newsletter-content {
    flex-direction: column;
    text-align: center;
    gap: 40px;
  }

  .newsletter-form {
    width: 100%;
    min-width: auto;
    flex-direction: column;
  }

  .newsletter-form .btn {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 640px) {
  .way-card {
    padding: 40px 30px;
  }

  .newsletter-section {
    padding: 40px 30px;
  }

  .newsletter-title {
    font-size: 24px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/GetInvolved.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iFAAiF;EACjF,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uEAAuE;EACvE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gFAAgF;AAClF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;EAC1C,oCAAoC;EACpC,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".get-involved {\n  background: var(--white);\n}\n\n.ways-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 32px;\n  margin-bottom: 64px;\n}\n\n.way-card {\n  padding: 56px 40px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  transition: var(--transition);\n}\n\n.way-card:hover {\n  transform: translateY(-4px);\n  box-shadow: var(--shadow-xl);\n}\n\n.way-icon {\n  width: 80px;\n  height: 80px;\n  border-radius: 20px;\n  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--white);\n  margin-bottom: 28px;\n  transition: var(--transition);\n}\n\n.way-icon svg {\n  width: 36px;\n  height: 36px;\n}\n\n.way-card:hover .way-icon {\n  transform: scale(1.1) rotate(-5deg);\n}\n\n.way-title {\n  font-size: 26px;\n  font-weight: 700;\n  color: var(--dark-color);\n  margin-bottom: 16px;\n}\n\n.way-description {\n  font-size: 15px;\n  line-height: 1.8;\n  color: var(--text-light);\n  margin-bottom: 28px;\n  flex-grow: 1;\n}\n\n.way-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--primary-color);\n  transition: var(--transition);\n}\n\n.way-link:hover {\n  gap: 12px;\n  color: var(--secondary-color);\n}\n\n.way-link svg {\n  flex-shrink: 0;\n}\n\n.newsletter-section {\n  background: linear-gradient(135deg, var(--dark-color) 0%, #2D2D2D 100%);\n  padding: 60px;\n  border-radius: 20px;\n  position: relative;\n  overflow: hidden;\n}\n\n.newsletter-section::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  right: -10%;\n  width: 400px;\n  height: 400px;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(0, 163, 224, 0.15) 0%, transparent 70%);\n}\n\n.newsletter-content {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 60px;\n}\n\n.newsletter-text {\n  flex: 1;\n  color: var(--white);\n}\n\n.newsletter-title {\n  font-size: 32px;\n  font-weight: 700;\n  color: var(--white);\n  margin-bottom: 12px;\n}\n\n.newsletter-description {\n  font-size: 16px;\n  line-height: 1.8;\n  color: rgba(255, 255, 255, 0.8);\n  max-width: 500px;\n}\n\n.newsletter-form {\n  display: flex;\n  gap: 12px;\n  flex-shrink: 0;\n  min-width: 400px;\n}\n\n.newsletter-input {\n  flex: 1;\n  padding: 16px 24px;\n  border-radius: 8px;\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  color: var(--white);\n  font-size: 15px;\n  transition: var(--transition);\n}\n\n.newsletter-input::placeholder {\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.newsletter-input:focus {\n  outline: none;\n  border-color: var(--secondary-color);\n  background: rgba(255, 255, 255, 0.15);\n}\n\n@media (max-width: 968px) {\n  .ways-grid {\n    grid-template-columns: 1fr;\n    gap: 24px;\n  }\n\n  .newsletter-content {\n    flex-direction: column;\n    text-align: center;\n    gap: 40px;\n  }\n\n  .newsletter-form {\n    width: 100%;\n    min-width: auto;\n    flex-direction: column;\n  }\n\n  .newsletter-form .btn {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n@media (max-width: 640px) {\n  .way-card {\n    padding: 40px 30px;\n  }\n\n  .newsletter-section {\n    padding: 40px 30px;\n  }\n\n  .newsletter-title {\n    font-size: 24px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
